import { Cookies } from 'quasar'

const LastLoginEmailCookieName = "LastLoginEmail";

export default {
    props: {
        returnUrl: String
    },

    data: function () {
        return {
            loading: false,
            model: this.emptyModel(),
            loginScreenType: {
                Email: 1,
                Password: 2,
                NewPasswordAndProfile: 3,
                SoftwareToken: 4,
                ForgotPasswordInitiate: 5,
                ForgotPasswordConfirm: 6
            }
        };
    },

    methods: {
        isPasswordValid: function (val) {
            return val.match(/^(?=.*[0-9])(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[a-zA-Z0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{12,}$/);
        },

        emptyModel() {
            let lastLogin = Cookies.has(LastLoginEmailCookieName) ? Cookies.get(LastLoginEmailCookieName) : null; 
            return {
                ErrorMessage: null,
                LoginScreen: 1, //loginScreenType.Email
                DisplayErrors: false,
                IdentityProviders: [],
                LoginData: {
                    Email: lastLogin,
                    Password: null,
                    ReturnUrl: this.returnUrl,
                },
                NewPasswordData: {
                    UserId: null,
                    UserEmail: null,
                    SessionId: null,
                    Password: null,
                    ConformPassword: null,
                    GivenName: null,
                    FamilyName: null,
                    ReturnUrl: this.returnUrl
                },
                SoftwareTokenData: {
                    UserId: null,
                    UserEmail: null,
                    SessionId: null,
                    Token: null,
                    ReturnUrl: this.returnUrl,
                },
                ForgotPasswordInitiateData: {
                    Email: null,
                    ReturnUrl: this.returnUrl
                },
                ForgotPasswordConfirmData: {
                    Email: null,
                    Password: null,
                    ConfirmPassword: null,
                    ConfirmationCode: null,
                    ReturnUrl: this.returnUrl
                }
            };
        },

        show() {
            this.$refs.dialog.show();
        },

        hide() {
            this.$refs.dialog.hide();
        },

        onDialogHide() {
            this.$emit('hide');
        },

        async onNextClick() {
            try {
                let validateResult = await this.$refs.modelEmailForm.validate();
                if (validateResult) {
                    this.loading = true;

                    let response = await this.$http.post('/ui/account/check_email', this.model.LoginData, {});
                    let responseData = response.body;
                    if (responseData.resultType == 99) {
                        this.model.ErrorMessage = responseData.message ? responseData.message : 'Something went wrong';
                        this.model.DisplayErrors = true;
                        return false;
                    } else if (responseData.resultType == 4) {
                        this.onSignInWithExternalProvider(responseData.identityProviderId);
                    } else {
                        this.model.LoginScreen = this.loginScreenType.Password;
                        this.model.DisplayErrors = false;

                        if (responseData.allowedIdentityProviders.length > 0) {
                            this.model.IdentityProviders = responseData.allowedIdentityProviders;
                        }
                    }
                    return true;
                }
                else
                    return false;
            } catch (ex) {
                this.$processException(ex);
                return false;
            } finally {
                this.loading = false;
            }
        },

        async onBackClick() {
            this.model.LoginScreen = this.loginScreenType.Email;
            this.model.DisplayErrors = false;
        },

        async onForgotPasswordClick() {
            this.model.ForgotPasswordInitiateData.Email = this.model.LoginData.Email;
            this.model.LoginScreen = this.loginScreenType.ForgotPasswordInitiate;
            this.model.DisplayErrors = false;
        },

        async onSignInClick() {
            try {
                let validateResult = await this.$refs.modelPasswordForm.validate();
                if (validateResult) {
                    this.loading = true;

                    let response = await this.$http.post('/ui/account/login', this.model.LoginData, {});
                    let responseData = response.body;
                    if (responseData.resultType == 99) {
                        this.model.ErrorMessage = responseData.message ? responseData.message : 'Something went wrong';
                        this.model.DisplayErrors = true;
                        return false;
                    }
                    else if (responseData.resultType == 0) {
                        this.onSuccessfulLogin(responseData.returnUrl);
                    }
                    else if (responseData.resultType == 1) {
                        this.model.LoginScreen = this.loginScreenType.NewPasswordAndProfile;
                        this.model.DisplayErrors = false;

                        this.model.NewPasswordData.UserId = responseData.userId;
                        this.model.NewPasswordData.UserEmail = responseData.userEmail;
                        this.model.NewPasswordData.SessionId = responseData.sessionId;
                    }
                    else if (responseData.resultType == 2) {
                        this.model.LoginScreen = this.loginScreenType.SoftwareToken;
                        this.model.DisplayErrors = false;

                        this.model.SoftwareTokenData.UserId = responseData.userId;
                        this.model.SoftwareTokenData.UserEmail = responseData.userEmail;
                        this.model.SoftwareTokenData.SessionId = responseData.sessionId;
                    }
                    else if (responseData.resultType == 3) {
                        this.model.LoginScreen = this.loginScreenType.ForgotPasswordConfirm;
                        this.model.DisplayErrors = true;
                        this.model.ErrorMessage = "Password reset required for user due to security reasons";
                        this.model.ForgotPasswordConfirmData.Email = responseData.userId;
                    }
                    return true;
                }
                else
                    return false;
            }
            catch (ex) {
                this.$processException(ex);
                return false;
            }
            finally {
                this.loading = false;
            }
        },

        async onNewPasswordSendClick() {
            try {
                let validateResult = await this.$refs.modelNewPasswordForm.validate();
                if (validateResult) {
                    this.loading = true;

                    let response = await this.$http.post('/ui/account/update_password_and_profile', this.model.NewPasswordData, {});
                    let responseData = response.body;
                    if (responseData.resultType == 99) {
                        this.model.ErrorMessage = responseData.message ? responseData.message : 'Something went wrong';
                        this.model.DisplayErrors = true;
                        return false;
                    }
                    else if (responseData.resultType == 0) {
                        this.onSuccessfulLogin(responseData.returnUrl);
                    }
                    return true;
                }
                else
                    return false;
            }
            catch (ex) {
                this.$processException(ex);
                return false;
            }
            finally {
                this.loading = false;
            }
        },

        async onSoftwareTokenSendClick() {
            try {
                let validateResult = await this.$refs.modelSoftwareTokenForm.validate();
                if (validateResult) {
                    this.loading = true;

                    let response = await this.$http.post('/ui/account/submit_software_token', this.model.SoftwareTokenData, {});
                    let responseData = response.body;
                    if (responseData.resultType == 99) {
                        this.model.ErrorMessage = responseData.message ? responseData.message : 'Something went wrong';
                        this.model.DisplayErrors = true;
                        return false;
                    }
                    else if (responseData.resultType == 0) {
                        this.onSuccessfulLogin(responseData.returnUrl);
                    }
                    return true;
                }
                else
                    return false;
            }
            catch (ex) {
                this.$processException(ex);
                return false;
            }
            finally {
                this.loading = false;
            }
        },

        onSignInWithExternalProvider(providerName) {
            Cookies.set(LastLoginEmailCookieName,
                this.model.LoginData.Email,
                {
                    path: '/',
                    httpOnly: false,
                    secure: false,
                    expires: 30
                });

            let returnUrlParameterValue = encodeURIComponent(this.returnUrl);
            let queryParameters = 'providerName=' +
                providerName +
                '&returnUrl=' +
                returnUrlParameterValue +
                '&userEmail=' +
                encodeURIComponent(this.model.LoginData.Email);
            window.location.href = '/ui/account/login_external?'+queryParameters;
        },

        async onForgotPasswordInitiateClick() {
            try {
                let validateResult = await this.$refs.modelForgotPasswordInitiateForm.validate();
                if (validateResult) {
                    this.loading = true;

                    let response = await this.$http.post('/ui/account/forgot_password_initiate', this.model.ForgotPasswordInitiateData, {});
                    let responseData = response.body;
                    if (responseData.resultType == 99) {
                        this.model.ErrorMessage = responseData.message ? responseData.message : 'Something went wrong';
                        this.model.DisplayErrors = true;
                        return false;
                    }
                    else if (responseData.resultType == 0) {
                        this.model.ForgotPasswordConfirmData.Email = this.model.ForgotPasswordInitiateData.Email;
                        this.model.DisplayErrors = false;
                        this.model.LoginScreen = this.loginScreenType.ForgotPasswordConfirm;
                    }
                    return true;
                }
                else
                    return false;
            }
            catch (ex) {
                this.$processException(ex);
                return false;
            }
            finally {
                this.loading = false;
            }
        },

        async onForgotPasswordConfirmClick() {
            try {
                let validateResult = await this.$refs.modelForgotPasswordConfirmForm.validate();
                if (validateResult) {
                    this.loading = true;

                    let response = await this.$http.post('/ui/account/forgot_password_confirm', this.model.ForgotPasswordConfirmData, {});
                    let responseData = response.body;
                    if (responseData.resultType == 99) {
                        this.model.ErrorMessage = responseData.message ? responseData.message : 'Something went wrong';
                        this.model.DisplayErrors = true;
                        return false;
                    }
                    else if (responseData.resultType == 0) {
                        this.model.LoginData.Email = this.model.ForgotPasswordConfirmData.Email;
                        this.model.DisplayErrors = false;
                        this.model.LoginScreen = this.loginScreenType.Password;
                    }
                    return true;
                }
                else
                    return false;
            }
            catch (ex) {
                this.$processException(ex);
                return false;
            }
            finally {
                this.loading = false;
            }
        },

        onSuccessfulLogin(redirectUrl) {
            Cookies.set(LastLoginEmailCookieName,
                this.model.LoginData.Email,
                {
                    path: '/',
                    httpOnly: false,
                    secure: false,
                    expires: 30
                });

            window.location.href = redirectUrl;
        }
    }
}